/**
 * Croatian (Hrvatski) translations for Okulus Photography Platform
 */
export const hr = {
  common: {
    save: "Sačuvaj",
    cancel: "Otkaži",
    delete: "Obriši",
    edit: "Uredi",
    create: "Kreiraj",
    search: "Pretraži",
    filter: "Filtriraj",
    loading: "Učitavanje...",
    error: "Greška",
    success: "Uspjeh",
    confirm: "Potvrdi",
    close: "Zatvori",
    back: "Nazad",
    configure: "Konfiguriraj",
    configureTitle: "Postavke za {name}",
    configureDescription: "Dodijelite pohranu, jezik i podatke o tvrtki za ovog korisnika.",
    storageTab: "Pohrana",
    localizationTab: "Jezik",
    companyTab: "Tvrtka",
    noUserSelected: "Nije odabran korisnik",
    loadingSettings: "Učitavanje postavki...",
    failedToLoadSettings: "Nije moguće učitati postavke",
    storageProviderLabel: "Pružatelj pohrane",
    storageOptionLocal: "Lokalna pohrana",
    storageOptionR2: "Cloudflare R2",
    storageOptionB2: "Backblaze B2",
    storageOptionGcs: "Google Cloud Storage",
    storageLocalDescription: "Datoteke ostaju na lokalnom serveru (samo za testiranje).",
    storageR2Description: "Unesite Cloudflare R2 vjerodajnice za upload i download.",
    storageB2Description: "Unesite Backblaze B2 vjerodajnice za upload i download.",
    storageGcsDescription: "Unesite Google Cloud bucket i JSON service account-a.",
    timezoneLabel: "Vremenska zona",
    timezoneHint: "Primjer: Europe/Sarajevo",
    fields: {
      r2AccessKeyId: "Access Key ID",
      r2SecretAccessKey: "Secret Access Key",
      r2Endpoint: "Endpoint",
      r2BucketName: "Bucket ime",
      b2KeyId: "Key ID",
      b2ApplicationKey: "Application key",
      b2BucketName: "Bucket ime",
      b2Endpoint: "Endpoint (opcionalno)",
      b2Region: "Regija",
      gcsProjectId: "Project ID",
      gcsBucketName: "Bucket ime",
      gcsCredentialsJson: "Service account JSON",
    },
    next: "Sljedeće",
    previous: "Prethodno",
    upload: "Učitaj",
    download: "Preuzmi",
    downloaded: "Preuzeto",
    view: "Pregledaj",
    video: "Video",
    print: "Tisak",
    digital: "Digitalno",
    image: "Slika",
    actions: "Akcije",
    status: "Status",
    date: "Datum",
    time: "Vrijeme",
    total: "Ukupno",
    price: "Cijena",
    quantity: "Količina",
      storageSaved: "Pohrana spremljena",
      storageFailed: "Spremanje pohrane nije uspjelo",
      localizationSaved: "Jezik ažuriran",
      localizationFailed: "Ažuriranje jezika nije uspjelo",
      companySaved: "Podaci o tvrtki spremljeni",
      companyFailed: "Spremanje podataka o tvrtki nije uspjelo",
    yes: "Da",
    no: "Ne",
    page: "Stranica",
    of: "od",
    showing: "Prikazujem",
    refresh: "Osvježi",
    saving: "Sprema...",
    optional: "Opcionalno",
    backToGallery: "Natrag u galeriju",
  },

  auth: {
      pleaseLoginToContinue: "Molimo prijavite se da biste nastavili",
    login: "Prijava",
    projectNotActiveTitle: "Galerija još nije dostupna",
    projectNotActiveBody: "Ostavite svoj email i obavijestit ćemo vas čim sadržaj bude objavljen.",
    yourEmail: "Vaš email",
    emailPlaceholder: "vi@primjer.hr",
    notifyMe: "Obavijesti me",
    notifySuccess: "Zabilježeno. Poslat ćemo obavijest kad objavimo.",
    logout: "Odjava",
    register: "Registracija",
    email: "Email",
    password: "Lozinka",
    forgotPassword: "Zaboravili ste lozinku?",
    resetPassword: "Resetuj lozinku",
    welcomeBack: "Dobrodošli nazad",
    signIn: "Prijavite se",
    signOut: "Odjavite se",
    notRegistered: "Niste registrovani?",
    alreadyHaveAccount: "Već imate račun?",
    loginSuccess: "Uspješno prijavljivanje!",
    registerSuccess: "Račun uspješno kreiran!",
    passwordResetSuccess: "Lozinka uspješno promijenjena!",
    passwordsDontMatch: "Lozinke se ne poklapaju",
    passwordTooShortAuth: "Lozinka mora imati najmanje 8 znakova",
    enterEmail: "Molimo unesite email adresu",
    accountNotActivated: "Račun nije aktiviran. Kontaktirajte administratora.",
  },

  nav: {
    dashboard: "Kontrolna tabla",
    projects: "Projekti",
    images: "Slike",
    accessCodes: "Pristupni kodovi",
    orders: "Narudžbe",
    settings: "Postavke",
    gallery: "Galerija",
    cart: "Korpa",
    profile: "Profil",
    analytics: "Analitika",
    adminUsers: "Korisnici",
  },

  settings: {
    title: "Postavke",
    general: "Opće",
    security: "Sigurnost",
    system: "Sustav",
    systemDescription: "Konfigurirajte ime sustava i osnovni URL (globalno)",
    systemName: "Ime sustava",
    baseUrl: "Osnovni URL",
    systemNameGlobalNote: "Ova vrijednost se centralno upravlja i ista je za sve korisnike.",
    baseUrlHelp: "Osnovni URL se koristi za QR kodove i linkove i isti je za sve korisnike.",
    codeLoginLimit: "Max prijava po kodu",
    codeLoginLimitHelp: "Koliko puta se kod iz PDF-a smije koristiti",
    maxManualDigitalImages: "Max. digitalne slike (ručno preuzimanje)",
    maxManualDigitalImagesHelp: "Maksimalan broj digitalnih slika po pristupnom kodu bez paketa",
    maxManualDigitalImagesReached: "Dosegnut maksimalan broj digitalnih slika",
    save: "Spremi",
    pricing: "Cijene",
    shippingRates: "Troškovi dostave",
    shippingRatesTitle: "Troškovi dostave po zemlji",
    shippingRatesDescription: "Konfigurišite troškove dostave za pojedine države. Samo aktivne destinacije su dostupne pri plaćanju.",
    shippingRatesCountry: "Država",
    shippingRatesCost: "Trošak",
    shippingRatesActive: "Aktivno",
    shippingRatesActions: "Akcije",
    shippingRatesAddButton: "Dodaj državu",
    shippingRatesAddTitle: "Dodaj novu državu",
    shippingRatesSelectPlaceholder: "Odaberite državu...",
    shippingRatesCustomPlaceholder: "Unesite naziv države",
    shippingRatesCustomOption: "Druga država...",
    shippingRatesCostInputLabel: "Trošak dostave (€)",
    shippingRatesCostInputPlaceholder: "0.00",
    shippingRatesEmpty: "Još nema definisanih troškova dostave",
    shippingRatesToastSaved: "Trošak dostave spremljen",
    shippingRatesToastDeleted: "Trošak dostave obrisan",
    shippingRatesToastErrorPrefix: "Greška:",
    shippingRatesFormMissing: "Unesite državu i trošak",
    shippingRatesDeleteConfirm: "Obrisati ovaj trošak dostave?",
    shippingRatesCountryOptions: [
      "Njemačka",
      "Austrija",
      "Švicarska",
      "Bosna i Hercegovina",
      "Hrvatska",
      "Srbija",
      "Crna Gora",
      "Slovenija",
      "Sjeverna Makedonija",
    ],
    watermark: "Vodeni žig",
    paypal: "PayPal",
    storage: "Skladištenje",
    gallery: "Galerija",
    qrCode: "QR kod",
    notifications: "Obavještenja",
    localization: "Lokalizacija",
    legal: "Pravne stranice",
    legalTab: {
      title: "Pravne stranice",
      description: "Impressum, privatnost, dostava i druge footer stranice.",
      createButton: "Nova stranica",
      defaultsButton: "Dodaj zadane stranice",
      emptyState: "Još nema definisanih stranica.",
      inactiveBadge: "neaktivno",
      validationError: "Molimo popunite sva polja",
      deleteConfirm: "Obrisati ovu stranicu?",
      toastCreated: "Stranica je kreirana",
      toastUpdated: "Stranica je ažurirana",
      toastDeleted: "Stranica je obrisana",
      defaultsAlready: "Sve zadane stranice već postoje",
      defaultsCreated: "Zadane stranice su dodane",
      defaultsFailed: "Dodavanje zadanih stranica nije uspjelo",
      defaultContentNote: "Sadržaj možete prilagoditi u Postavke › Pravne stranice.",
      dialog: {
        createTitle: "Nova stranica",
        editTitle: "Uredi stranicu",
        description: "Slug se koristi u URL adresi. Sadržaj može sadržavati HTML.",
        slugLabel: "Slug",
        titleLabel: "Naslov",
        sortOrderLabel: "Redoslijed",
        activeLabel: "Aktivno",
        languageLabel: "Jezik",
        contentLabel: "Sadržaj ({lang})",
        slugPlaceholder: "impressum",
        titlePlaceholder: "Impressum",
      },
      buttons: {
        cancel: "Otkaži",
        save: "Sačuvaj",
        saving: "Čuvanje...",
      },
      defaultPages: {
        impressum: "Impressum",
        privacy: "Privatnost",
        terms: "Uslovi korištenja",
        contact: "Kontakt",
        shipping: "Dostava",
        payment: "Načini plaćanja",
      },
    },

    pricePerImage: "Cijena po slici",
    pricePerVideo: "Cijena po videu",
    currency: "Valuta",

    watermarkEnabled: "Vodeni žig omogućen",
    watermarkText: "Tekst vodenog žiga",
    watermarkLogo: "Logo vodenog žiga",
    watermarkPosition: "Pozicija vodenog žiga",
    watermarkOpacity: "Prozirnost vodenog žiga",
    center: "Centar",
    topLeft: "Gore lijevo",
    topRight: "Gore desno",
    bottomLeft: "Dole lijevo",
    bottomRight: "Dole desno",
    tiled: "Pločice",

    paypalMode: "PayPal mod",
    sandbox: "Sandbox (test)",
    live: "Live (produkcija)",
    paypalClientId: "PayPal Client ID",
    paypalClientSecret: "PayPal Client Secret",

    gcs: "Cloudflare R2",
    gcsProjectId: "R2 Access Key ID",
    gcsBucketName: "R2 Bucket Name",
    gcsCredentials: "R2 Secret Access Key",

    settingsSaved: "Postavke su sačuvane",
    settingsFailed: "Greška pri čuvanju postavki",

    language: "Jezik",
    timezone: "Vremenska zona",
    dateFormat: "Format datuma",

    pleaseLogin: "Molimo prijavite se",
    pricingDescription: "Konfigurišite cijene za slike",
    watermarkDescription: "Konfigurišite vodeni žig za slike",
    gcsDescription: "Konfigurišite Cloudflare R2 za slike",
    r2Title: "Cloudflare R2",
    r2Description: "Konfigurišite Cloudflare R2 skladište za slike",
    r2AccessKeyId: "R2 Access Key ID",
    r2SecretAccessKey: "R2 Secret Access Key",
    r2Endpoint: "R2 Endpoint (accountid.r2.cloudflarestorage.com)",
    r2BucketName: "R2 Bucket Name",
    r2TestConnection: "Testiraj R2 konekciju",
    r2TestSuccess: "R2 konekcija uspješna",
    r2TestFailed: "R2 konekcija neuspješna",
    r2FetchUsage: "Dohvati iskorištenost",
    r2UsageLabel: "Iskorištenost Bucketa",
    r2UsageObjects: "Objekti",
    r2UsageBytes: "Ukupna veličina",
    r2UsageFailed: "Neuspješno dohvaćanje iskorištenosti",
    localizationDescription: "Odaberite jezik interfejsa",
    downloadLinkDays: "Važenje linka za preuzimanje (dani)",
    downloadLinkDaysHelp: "Koliko dugo kupci mogu koristiti ZIP preuzimanje",
    emailNotificationsEnabled: "Omogući email obavještenja",
    notificationEmail: "Email za obavještenja",
    smtpPassword: "SMTP lozinka",
    paypalDescription: "Konfigurišite PayPal za plaćanja",
    emailNotifications: "Email obavještenja",
    emailNotificationsDescription: "Konfigurišite SMTP server za slanje email obavještenja",
    enableEmailNotifications: "Omogući email obavještenja",
    manageDescription: "Upravljajte postavkama vaše platforme",
    smtpSettings: "SMTP postavke",
    smtpHost: "SMTP Host",
    smtpPort: "SMTP Port",
    smtpUser: "SMTP korisničko ime",
    smtpFrom: "Email pošiljaoca",
    smtpTestConnection: "Testiraj SMTP",
    smtpTestSuccess: "SMTP test email poslan",
    smtpTestFailed: "SMTP test neuspješan",
    smtpTestRecipient: "Test primatelj",
    sendInvoiceEmail: "Automatski pošalji račun putem e-pošte",
    companyInfo: "Firma / Fakturisanje",
    companyInfoDescription: "Podaci o firmi za fakture i pravne dokumente",
    companyName: "Naziv firme",
    companyAddressLine1: "Adresa linija 1",
    companyAddressLine2: "Adresa linija 2",
    companyPostalCode: "Poštanski broj",
    companyCity: "Grad",
    companyCountry: "Država",
    companyVatId: "PDV ID",
    companyTaxNumber: "Porezni broj",
    companyTaxRate: "Stopa poreza (%)",
    companyEmail: "Email firme",
    companyPhone: "Telefon firme",
    companyWebsite: "Web stranica",
    companyBankName: "Naziv banke",
    companyIban: "IBAN",
    companySwift: "SWIFT/BIC",
    companyLogoGcsKey: "Logo ključ skladišta",
    companyLogoUploadLabel: "Upload logotipa",
    companyLogoUploadButton: "Postavi logo",
    companyLogoPreview: "Trenutni logo",
    companyLogoNoFile: "Logo nije odabran",
    companyInvoiceFooter: "Fusnota na fakturi",
    placeholders: {
      pricePerImage: "5.00",
      pricePerVideo: "10.00",
      watermarkText: "Photography",
      companyName: "Moja Firma d.o.o.",
      companyVatId: "HR12345678901",
      companyTaxNumber: "123/456/7890",
      companyTaxRate: "25.00",
      companyAddressLine1: "Ulica 1",
      companyAddressLine2: "Sprat / Dodatak",
      companyPostalCode: "10000",
      companyCity: "Zagreb",
      companyCountry: "Hrvatska",
      companyEmail: "info@firma.hr",
      companyPhone: "+385 1 123456",
      companyWebsite: "https://www.firma.hr",
      companyBankName: "Naziv banke",
      companyIban: "HR12 2345 6789 1234 5678 9",
      companySwift: "SWIFTHRXX",
      companyLogoGcsKey: "logo/putanja.png",
      companyInvoiceFooter: "Dodatne napomene za račun",
      paypalClientId: "PayPal Client ID",
      paypalClientSecret: "PayPal Client Secret",
      r2AccessKeyId: "ACCESS_KEY_ID",
      r2SecretAccessKey: "SECRET_ACCESS_KEY",
      r2Endpoint: "accountid.r2.cloudflarestorage.com",
      r2BucketName: "bucket-name",
      smtpHost: "smtp.gmail.com",
      smtpPort: "587",
      smtpUser: "korisnik@gmail.com",
      smtpPassword: "lozinka",
      smtpFrom: "noreply@primjer.hr",
      smtpTestRecipient: "primatelj@primjer.hr",
      notificationEmail: "ime@primjer.hr",
    },
    storageMonitoring: "Praćenje prostora za pohranu",
    storageMonitoringDescription: "Pratite ukupnu veličinu učitanih datoteka",
    storageProviderTitle: "Pružatelj pohrane",
    storageProviderDescription: "Odaberite gdje se pohranjuju originali i pregledi.",
    storageProviderLabel: "Pružatelj",
    storageProviderPlaceholder: "Odaberite pohranu",
    storageProviderHelp: "Cloud pohrana sprječava gubitak datoteka nakon deploy-a.",
    localStorageWarningTitle: "Lokalna pohrana samo za testiranje",
    localStorageWarning: "Uploadovi ostaju na serverskom disku i brišu se pri svakom deploymentu. Koristite R2 ili GCS za produkciju.",
    useLocalStorage: "Prebaci na lokalnu pohranu",
    storageUsed: "Iskorišteno",
    storageRemaining: "Preostalo",
    storageUsagePercent: "Postotak iskorištenosti",
    storageLimit: "Limit pohrane",
    storageOverLimit: "Prekoračen limit pohrane",
    storageOverLimitMessage: "Trenutna potrošnja premašuje postavljeni limit. Povećajte limit ili obrišite stare datoteke.",
    storageNearLimit: "Približava se limitu",
    storageNearLimitMessage: "Koristite više od 80% dostupnog prostora. Razmislite o povećanju limita.",
    configureStorageLimit: "Konfiguriraj limit pohrane",
    storageLimitGB: "Limit pohrane (GB)",
    storageLimitHelp: "Maksimalna dozvoljena veličina učitanih datoteka",
    currentLimit: "Trenutni limit",
    storageLoadError: "Greška pri učitavanju informacija o pohrani",
    storageLimitUpdated: "Limit pohrane je ažuriran",
    storageLimitPasswordTitle: "Potrebna super lozinka",
    storageLimitPasswordDescription: "Unesite super lozinku za promjenu limita pohrane.",
    password: "Lozinka",
    passwordCorrect: "Pristup odobren",
    passwordIncorrect: "Netočna lozinka",
    currentPassword: "Trenutna lozinka",
    newPassword: "Nova lozinka",
    confirmPassword: "Potvrdi lozinku",
    passwordMismatch: "Lozinke se ne poklapaju",
    passwordTooShort: "Lozinka mora imati najmanje 6 znakova",
    currentPasswordRequired: "Trenutna lozinka je obavezna",
    changeSuperPassword: "Promijeni super lozinku",
    changeSuperPasswordDesc: "Promijenite lozinku koja štiti osjetljive postavke.",
    twoFactorAuth: "Dvofaktorska autentifikacija",
    twoFactorAuthDescription: "Povećajte sigurnost svog računa s 2FA",
    twoFactorEnabled: "2FA je aktivirana",
    twoFactorDisabled: "2FA je deaktivirana",
    twoFactorProtected: "Vaš račun je zaštićen s 2FA",
    twoFactorNotProtected: "Aktivirajte 2FA za dodatnu sigurnost",
    twoFactorBackupCodes: "Backup kodovi",
    twoFactorBackupCodesRemaining: "{count} neiskorištenih kodova dostupno",
    twoFactorGenerateNew: "Generiraj nove",
    twoFactorImportantNote: "Važna napomena",
    twoFactorAuthenticatorNote: "Koristite aplikaciju za autentifikaciju kao što su Google Authenticator, Microsoft Authenticator ili Authy za generiranje 2FA kodova.",
    twoFactorEnableTitle: "Aktiviraj dvofaktorsku autentifikaciju",
    twoFactorEnableDescription: "Skenirajte QR kod s vašom aplikacijom za autentifikaciju",
    twoFactorManualCode: "Ili unesite ovaj kod ručno:",
    twoFactorVerificationCode: "Kod za potvrdu iz vaše aplikacije",
    twoFactorVerificationCodePlaceholder: "123456",
    twoFactorDisableTitle: "Deaktiviraj dvofaktorsku autentifikaciju",
    twoFactorDisableDescription: "Unesite lozinku za deaktivaciju 2FA",
    twoFactorDisableWarning: "⚠️ Upozorenje: Deaktiviranje 2FA smanjuje sigurnost vašeg računa.",
    twoFactorBackupCodesTitle: "Vaši backup kodovi",
    twoFactorBackupCodesDescription: "Spremite ove kodove na sigurno mjesto. Svaki kod se može koristiti samo jednom.",
    twoFactorBackupCodesCopyAll: "Kopiraj sve kodove",
    twoFactorBackupCodesImportant: "⚠️ Važno: Ovi kodovi se prikazuju samo jednom. Spremite ih sigurno!",
    twoFactorBackupCodesSaved: "Spremio sam kodove",
    twoFactorLoginTitle: "Dvofaktorska autentifikacija",
    twoFactorLoginDescription: "Unesite 6-znamenkasti kod iz vaše aplikacije za autentifikaciju",
    twoFactorLoginCode: "2FA kod",
    twoFactorLoginCodePlaceholder: "123456",
    twoFactorLoginBackupHint: "Možete također koristiti backup kod",
    twoFactorLoginVerify: "Potvrdi",
    twoFactorLoginBack: "Natrag na prijavu",
    twoFactorEnterCode: "Molimo unesite vaš 2FA kod",
    twoFactorInvalidCode: "Nevažeći 2FA kod",
    twoFactorActivated: "Dvofaktorska autentifikacija aktivirana!",
    twoFactorDeactivated: "Dvofaktorska autentifikacija deaktivirana",
    twoFactorBackupCodesGenerated: "Novi backup kodovi generirani",
    twoFactorCodeCopied: "Kopirano u međuspremnik",
    twoFactorAllCodesCopied: "Svi backup kodovi kopirani",
  },

  printFormats: {
    title: "Formati za tisak",
    newFormat: "Novi format",
    editFormat: "Uredi format",
    noFormatsMessage: "Nema definiranih formata. Kreirajte svoj prvi format.",
    dialogDescription: "Definirajte svojstva formata za tisak",
    name: "Naziv",
    width: "Širina",
    height: "Visina",
    unit: "Jedinica",
    price: "Cijena ({currency})",
    active: "Aktivan",
    cancel: "Otkaži",
    save: "Spremi",
    deleteConfirm: "Zaista obrisati format?",
    created: "Format kreiran",
    updated: "Format ažuriran",
    deleted: "Format obrisan",
    namePlaceholder: "npr. 10x15 cm Standard",
    passwordCorrect: "Pristup odobren",
    passwordIncorrect: "Netočna lozinka",
  },

  adminUsers: {
    title: "Upravljanje korisnicima",
    back: "Natrag",
    searchPlaceholder: "Pretraga (Email/Ime)",
    createTitle: "Kreiraj novog korisnika",
    email: "Email",
    name: "Ime",
    password: "Lozinka",
    role: "Uloga",
    roleUser: "Korisnik",
    roleAdmin: "Admin",
    active: "Aktivan",
    create: "Kreiraj",
    listTitle: "Lista korisnika",
    configure: "Podesi",
    configureTitle: "Upravljanje postavkama za {name}",
    configureDescription: "Dodijeli skladište, jezik i podatke o firmi za ovog korisnika.",
    storageTab: "Skladište",
    localizationTab: "Jezik",
    companyTab: "Firma",
    noUserSelected: "Nijedan korisnik nije odabran",
    loadingSettings: "Učitavanje postavki...",
    failedToLoadSettings: "Postavke nije moguće učitati",
    storageProviderLabel: "Dobavljač skladišta",
    storageOptionLocal: "Lokalni upload",
    storageOptionR2: "Cloudflare R2",
    storageOptionB2: "Backblaze B2",
    storageOptionGcs: "Google Cloud Storage",
    storageLocalDescription: "Fajlovi ostaju na serveru (preporučeno samo za demo).",
    storageR2Description: "Unesite Cloudflare R2 akreditive za upload/preuzimanje.",
    storageB2Description: "Unesite Backblaze B2 akreditive za upload/preuzimanje.",
    storageGcsDescription: "Unesite Google Cloud bucket i JSON service account.",
    timezoneLabel: "Vremenska zona",
    timezoneHint: "Primjer: Europe/Sarajevo",
    fields: {
      r2AccessKeyId: "Access Key ID",
      r2SecretAccessKey: "Secret Access Key",
      r2Endpoint: "Endpoint",
      r2BucketName: "Naziv bucket-a",
      b2KeyId: "Key ID",
      b2ApplicationKey: "Application Key",
      b2BucketName: "Naziv bucket-a",
      b2Endpoint: "Endpoint (opcionalno)",
      b2Region: "Regija",
      gcsProjectId: "Project ID",
      gcsBucketName: "Naziv bucket-a",
      gcsCredentialsJson: "Service account JSON",
    },
    actions: "Akcije",
    delete: "Obriši",
    noneFound: "Nema pronađenih korisnika",
    activateUser: "Aktiviraj korisnika",
    activateUserDescription: "Dodijelite kvotu skladišta prije aktivacije korisnika.",
    storageQuota: "Kvota skladišta",
    storageQuotaHelp: "Preporučeno: 50GB za obične korisnike",
    activate: "Aktiviraj",
    toasts: {
      created: "Korisnik kreiran",
      updated: "Korisnik ažuriran",
      deleted: "Korisnik obrisan",
      createFailed: "Kreiranje nije uspjelo",
      updateFailed: "Ažuriranje nije uspjelo",
      activateFailed: "Aktivacija nije uspjela",
      roleFailed: "Promjena uloge nije uspjela",
      deleteFailed: "Brisanje nije uspjelo",
      storageSaved: "Skladišne postavke sačuvane",
      storageFailed: "Skladišne postavke nisu sačuvane",
      localizationSaved: "Jezik ažuriran",
      localizationFailed: "Greška pri ažuriranju jezika",
      companySaved: "Podaci o firmi sačuvani",
      companyFailed: "Greška pri čuvanju podataka o firmi",
    },
  },

  analytics: {
    title: "Analitika",
    subtitle: "Pregled performansi i statistika",
    pleaseLogin: "Molimo prijavite se za pristup analitici.",
    totalRevenue: "Ukupan prihod",
    fromOrders: "Iz {count} narudžbi",
    orders: "Narudžbe",
    paidOrders: "Plaćenih narudžbi",
    conversion: "Konverzija",
    codesUsed: "{converted} / {total} kodova",
    projects: "Projekti",
    imagesCount: "{count} slika",
    revenueByMonth: "Prihod po mjesecima",
    last12Months: "Zadnjih 12 mjeseci",
    topProjects: "Najpopularniji projekti",
    top5Projects: "Top 5 projekata po prihodu",
    revenueLabel: "Prihod ({currency})",
  },

  systemLogs: {
    title: "Sistemski logovi",
    subtitle: "Sve sistemske aktivnosti i API pozivi",
    filters: "Filteri i pretraga",
    refresh: "Osvježi",
    searchPlaceholder: "Traži po korisniku, akciji, detaljima...",
    allActions: "Sve akcije",
    actions: {
      orderCreate: "Kreirana narudžba",
      orderUpdate: "Ažurirana narudžba",
      projectCreate: "Kreiran projekt",
      imageUpload: "Upload slike",
      userLogin: "Prijava korisnika",
      userLogout: "Odjava korisnika",
      paymentSuccess: "Uspješno plaćanje",
      paymentFailed: "Neuspješno plaćanje",
    },
    allLevels: "Svi nivoi",
    levels: {
      info: "Info",
      warning: "Upozorenje",
      error: "Greška",
      success: "Uspjeh",
    },
    clear: "Resetiraj",
    found: "Pronađeno {count} zapisa",
    pageOf: "Stranica {page} od {total}",
    columns: {
      timestamp: "Vremenski pečat",
      level: "Nivo",
      action: "Akcija",
      user: "Korisnik",
      details: "Detalji",
      ip: "IP",
    },
    noneFound: "Nema pronađenih logova",
  },

  dashboard: {
    welcomeBack: "Dobrodošli nazad",
    pleaseLogin: "Molimo prijavite se za pristup kontrolnoj tabli.",
    manage: "Upravljajte svojim fotografskim projektima, pratite prodaju i analizirajte performanse.",
    myProjects: "Moji projekti",
    quickStats: "Brza statistika",
    totalProjects: "Ukupno projekata",
    totalImages: "Ukupno slika",
    totalOrders: "Ukupno narudžbi",
    totalRevenue: "Ukupan prihod",
    quickActions: "Brze akcije",
    createProject: "Kreiraj novi projekat",
    viewAnalytics: "Pogledaj analitiku",
    manageSettings: "Upravljaj postavkama",
    recentActivity: "Nedavne aktivnosti",
    recentProjects: "Nedavni projekti",
    allProjects: "Svi projekti",
    noProjectsTitle: "Nema projekata",
    noProjectsDescription: "Počnite kreiranjem vašeg prvog fotografskog projekta i počnite prodavati slike.",
    createFirstProject: "Kreiraj prvi projekt",
    manageSettingsDescription: "Konfigurišite postavke",
  },

  projects: {
    title: "Projekti",
    createProject: "Kreiraj projekat",
    editProject: "Uredi projekat",
    deleteProject: "Obriši projekat",
    projectName: "Naziv projekta",
    projectNumber: "Broj projekta",
    projectDescription: "Opis projekta",
    projectStatus: "Status projekta",
    draft: "Nacrt",
    active: "Aktivan",
    archived: "Arhiviran",
    totalImages: "Ukupno slika",
    totalCodes: "Ukupno kodova",
    totalViews: "Ukupno pregleda",
    createdAt: "Kreirano",
    updatedAt: "Ažurirano",
    selectAvatar: "Odaberi avatar",
    noProjects: "Nema projekata",
    createFirstProject: "Kreirajte svoj prvi projekat",
    confirmDelete: "Da li ste sigurni da želite obrisati ovaj projekat?",
    projectDeleted: "Projekat je obrisan",
    projectCreated: "Projekat je kreiran",
    projectUpdated: "Projekat je ažuriran",
    backToDashboard: "Nazad na Dashboard",
    projectsCount: "{count} projekat | {count} projekata",
    noDescription: "Nema opisa",
    viewImages: "Pregledaj slike",
    viewVideos: "Pregledaj videozapise",
    viewCodes: "Pristupni kodovi",
    editButton: "Uredi",
    deleteButton: "Obriši",
  },

  orders: {
    title: "Narudžbe",
    orderNumber: "Broj narudžbe",
    orderDate: "Datum narudžbe",
    orderStatus: "Status narudžbe",
    pending: "Na čekanju",
    paid: "Plaćeno",
    failed: "Neuspjelo",
    refunded: "Vraćeno",
    shipped: "Dostavljeno",
    customerName: "Ime kupca",
    customerEmail: "Email kupca",
    totalAmount: "Ukupan iznos",
    totalOrders: "Ukupno narudžbi",
    items: "Stavke",
    viewOrder: "Pregledaj narudžbu",
    noOrders: "Nema narudžbi",
    orderDetails: "Detalji narudžbe",
    orderInfo: "Informacije o narudžbi",
    paymentDetails: "Detalji plaćanja",
    transactionId: "ID transakcije",
    paymentMethod: "Način plaćanja",
    paymentStatus: "Status",
    downloadAll: "Preuzmi sve slike",
    download: "Preuzmi",
    image: "Slika",
    imagesAvailableAfterPayment: "Slike će biti dostupne za preuzimanje nakon uspješne uplate.",
    imageCount: "slika",
    imageCountPlural: "slika",
    ordersDescription: "Pregled svih narudžbi iz vaših projekata",
    project: "Projekat",
    shipping: "Dostava",
    shippingDetails: "Detalji dostave",
    shippingAddress: "Adresa dostave",
    shippingOverview: "Pregled dostave",
    manageShipping: "Upravljaj dostavom za narudžbu s tiskanim artiklima",
    printItems: "Tiskani artikli",
    printItemsTotal: "Ukupno tiskanih artikala",
    loadingOrder: "Učitavanje detalja narudžbe...",
    orderNotFound: "Narudžba nije pronađena.",
    noOrderSelected: "Nije odabrana narudžba.",
    noPrintItems: "Ova narudžba nema tiskanih artikala za dostavu.",
    printShippingLabel: "Ispiši naljepnicu za dostavu",
    markAsShipped: "Označi kao dostavljeno",
    viewFullOrder: "Pregledaj cijelu narudžbu",
    backToOrders: "Natrag na narudžbe",
    requiresShipping: "Dostava",
    delivery: "Dostava",
    pickup: "Preuzimanje",
    shippingLabel: "NALJEPNICA ZA DOSTAVU",
    shipTo: "DOSTAVI NA:",
    packageContents: "SADRŽAJ PAKETA",
    printLabel: "Ispiši naljepnicu",
    deliveryNote: "Otpremnica",
    standardPrint: "Standardni tisak",
    cancelled: "Otkazano",
    cancelOrder: "Otkaži narudžbu",
    orderCancelled: "Narudžba uspješno otkazana",
    confirmCancel: "Jeste li sigurni da želite otkazati ovu narudžbu? Ova radnja se ne može poništiti.",
    filters: "Filteri",
    filtered: "filtrirano",
    searchPlaceholder: "Pretraži po broju narudžbe, imenu ili emailu...",
    allStatuses: "Svi statusi",
    allProjects: "Svi projekti",
    clearFilters: "Obriši filtere",
    downloaded: "Preuzeto",
    downloadedAt: "Preuzeto",
    notDownloadedYet: "Još nije preuzeto",
    markAsPaid: "Označi kao plaćeno",
    markingAsPaid: "Označavanje kao plaćeno...",
    markedAsPaid: "Narudžba uspješno označena kao plaćena",
    downloadInvoice: "Preuzmi račun",
    noInvoice: "Račun nije dostupan",
    invoiceDownloaded: "Račun preuzet",
  },

  cart: {
    title: "Korpa",
    emptyCart: "Vaša korpa je prazna",
    continueShopping: "Nastavi kupovinu",
    itemRemoved: "Stavka uklonjena iz korpe",
    cartUpdated: "Korpa ažurirana",
    item: "stavka",
    items: "stavki",
    subtotal: "Međuzbir",
    total: "Ukupno",
    proceedToCheckout: "Pređi na naplatu",
    checkout: "Pređi na naplatu",
  },

  checkout: {
    title: "Naplata",
    customerInfo: "Informacije o kupcu",
    customerInfoDesc: "Unesite vaše podatke za narudžbu",
    digitalDeliveryOnly: "Digitalna isporuka – adresa nije potrebna.",
    name: "Ime",
    namePlaceholder: "Ime i prezime",
    email: "Email",
    emailPlaceholder: "vas@email.com",
    addressLine1: "Adresa 1",
    addressLine1Placeholder: "Ulica i broj",
    addressLine2: "Adresa 2",
    addressLine2Placeholder: "Stan / Sprat (opcionalno)",
    postalCode: "Poštanski broj",
    postalCodePlaceholder: "Poštanski broj",
    city: "Grad",
    cityPlaceholder: "Grad",
    country: "Država",
    countryPlaceholder: "Odaberite državu",
    phone: "Telefon",
    phonePlaceholder: "Broj telefona",
    deliveryType: "Način dostave",
    homeDelivery: "Dostava na adresu",
    selfPickup: "Osobno preuzimanje",
    billingAddress: "Adresa za naplatu",
    differentBillingAddress: "Drugačija adresa za naplatu",
    billingAddressLine1: "Adresa za naplatu red 1",
    billingAddressLine2: "Adresa za naplatu red 2",
    billingPostalCode: "Poštanski broj za naplatu",
    billingCity: "Grad za naplatu",
    billingCountry: "Država za naplatu",
    shippingCost: "Troškovi dostave",
    shippingCostDesc: "Unesite troškove dostave za fizičke proizvode.",
    paymentMethod: "Način plaćanja",
    orderSummary: "Sažetak narudžbe",
    payWithPayPal: "Sigurno plati preko PayPal-a",
    placeOrder: "Potvrdi narudžbu",
    paymentSuccess: "Plaćanje uspješno!",
    paymentFailed: "Plaćanje nije uspjelo",
    pleaseEnterDetails: "Molimo unesite vaše podatke",
    paypalNotConfigured: "PayPal nije konfigurisan",
    thankYou: "Hvala na narudžbi!",
    orderConfirmation: "Vaša narudžba je primljena i bit će obrađena uskoro.",
    downloadInstructions: "Primit ćete email sa linkovima za preuzimanje vaših slika.",
    backToGallery: "Povratak na galeriju",
    orderSuccess: "Narudžba uspješna!",
    orderSuccessDesc: "Vaša narudžba je uspješno poslana.",
    downloadInfoSent: "Informacije za preuzimanje poslane su na vaš email.",
    subtotal: "Međuzbroj",
    processing: "Obrada u tijeku...",
    pickupAddress: "Preuzimanje",
  },

  gallery: {
    alreadyPurchased: "Već kupljeno",
    title: "Galerija",
    enterAccessCode: "Unesite pristupni kod",
    accessCode: "Pristupni kod",
    projectNumber: "Broj projekta",
    login: "Prijavi se",
    invalidCode: "Neispravan pristupni kod",
    accessCodeLimitReached: "Dosegnut limit korištenja pristupnog koda",
    selectImages: "Odaberi slike",
    addToCart: "Dodaj u korpu",
    viewCart: "Pogledaj korpu",
    noImagesSelected: "Nema odabranih slika",
    scanQRCode: "Ili skenirajte QR kod",
    scanInstruction: "Skenirajte QR kod sa vaše kartice",
    emptyGallery: "Još nema slika ili videozapisa",
    selectProductType: "Odaberite tip proizvoda",
    productType: "Tip proizvoda",
    digital: "Digitalni (preuzimanje)",
    print: "Tiskani (fizička fotografija)",
    selectFormat: "Odaberite format",
    loadingFormats: "Učitavanje formata...",
    noFormatsAvailable: "Nema dostupnih formata za tisak. Molimo kontaktirajte fotografa.",
    addToCartButton: "Dodaj u košaricu",
    logout: "Odjava",
    sessionExpired: "Vaša sesija je istekla. Molimo prijavite se ponovo.",
    projectNotActiveTitle: "Galerija još nije dostupna",
    projectNotActiveBody: "Ostavite svoj email i obavijestit ćemo vas čim sadržaj bude objavljen.",
    yourEmail: "Vaš email",
    emailPlaceholder: "vi@primjer.hr",
    notifyMe: "Obavijesti me",
    notifySuccess: "Zabilježeno! Poslat ćemo vam email kada bude objavljeno.",
  },

  shop: {
    imprint: "Impressum",
    privacyPolicy: "Privatnost",
    terms: "Uslovi korištenja",
    contact: "Kontakt",
    returns: "Povrat",
    shipping: "Dostava",
    payment: "Načini plaćanja",
    footerDisclaimer: "Sve cijene uključuju PDV. Podložno promjenama.",
  },

  validation: {
    required: "Ovo polje je obavezno",
    invalidEmail: "Neispravna email adresa",
    passwordTooShort: "Lozinka mora imati najmanje 8 karaktera",
    passwordMismatch: "Lozinke se ne poklapaju",
  },

  stats: {
    totalProjects: "Ukupno projekata",
    totalImages: "Ukupno slika",
    totalOrders: "Ukupno narudžbi",
    totalRevenue: "Ukupan prihod",
  },

  downloads: {
    title: "Preuzimanja",
    errorTitle: "Greška pri preuzimanju",
    invalidOrExpiredLink: "Nevažeći ili istekao link za preuzimanje",
    enterOrderId: "Unesite broj narudžbe",
    orderIdLabel: "Broj narudžbe",
    orderIdPlaceholder: "Unesite broj narudžbe",
    submit: "Potvrdi",
    invalidOrderNumber: "Nevažeći broj narudžbe",
    allDownloaded: "Sve slike su preuzete!",
    downloadAll: "Preuzmi sve",
    download: "Preuzmi",
    orderNotFound: "Narudžba nije pronađena ili pristup odbijen",
    noImages: "Nema slika za ovu narudžbu",
    downloadStarted: "Preuzimanje započeto za",
    downloadError: "Greška pri preuzimanju",
    downloadFailed: "Preuzimanje {filename} nije uspjelo",
    allDownloadsStarted: "Sva preuzimanja započeta",
  },

  videos: {
    title: "Videozapisi",
    videoDeleted: "Video obrisan",
    downloadLinkError: "Greška pri kreiranju download linka",
    backToProject: "Nazad na projekat",
    uploadVideos: "Učitaj videozapise",
    selectFiles: "Odaberi datoteke",
    maxFileSize: "Maksimalna veličina datoteke: 15GB po videozapisu",
    dragDrop: "Prevucite video datoteke ovdje ili kliknite za odabir",
    uploading: "Učitavanje...",
    completed: "Završeno",
    pending: "Na čekanju",
    error: "Greška",
    confirmDelete: "Da li ste sigurni da želite obrisati ovaj video?",
    deleteVideo: "Obriši video",
    noVideos: "Nema videozapisa",
    uploadFirstVideo: "Učitajte svoj prvi video",
    uploadFailed: "Učitavanje nije uspjelo",
  },

  legal: {
    contactTitle: "Kontakt",
    contactDefault: "Inhalt kann in Einstellungen › Legal angepasst werden.",
    impressumTitle: "Impressum",
    impressumDefault: "Test",
  },

  forgotPassword: {
    title: "Zaboravljena lozinka",
    subtitle: "Resetujte svoju lozinku",
    emailSent: "Email poslan",
    checkInbox: "Provjerite svoj email inbox",
    emailSentMessage: "Ako postoji račun sa email adresom <strong>{email}</strong>, poslali smo vam link za resetovanje lozinke.",
    checkSpam: "Molimo provjerite i spam folder ako ne vidite email za nekoliko minuta.",
    backToLogin: "Nazad na prijavu",
    enterEmail: "Unesite vašu email adresu",
    emailPlaceholder: "vas@email.com",
    sendResetLink: "Pošalji reset link",
    resetInstructions: "Unesite vašu email adresu i poslat ćemo vam link za resetovanje lozinke.",
  },

  resetPassword: {
    title: "Resetuj lozinku",
    subtitle: "Unesite novu lozinku",
    newPassword: "Nova lozinka",
    confirmPassword: "Potvrdi lozinku",
    resetButton: "Resetuj lozinku",
    success: "Lozinka uspješno promijenjena!",
    successMessage: "Vaša lozinka je promijenjena. Bit ćete preusmjereni na stranicu za prijavu.",
    invalidToken: "Nevažeći ili istekao token",
    invalidTokenMessage: "Ovaj reset link je nevažeći ili je istekao. Molimo zatražite novi reset lozinke.",
    requestNew: "Zatraži novi reset",
    verifying: "Provjera reset linka...",
    passwordMismatch: "Lozinke se ne poklapaju",
    passwordTooShort: "Lozinka mora imati najmanje 8 znakova",
  },

  notFound: {
    title: "404",
    subtitle: "Stranica nije pronađena",
    message: "Žao nam je, stranica koju tražite ne postoji.",
    submessage: "Možda je premještena ili obrisana.",
    goHome: "Početna stranica",
  },

  register: {
    title: "Kreiraj račun",
    subtitle: "Kreirajte svoj {appTitle} račun",
    name: "Puno ime",
    namePlaceholder: "Ime i prezime",
    email: "Email",
    emailPlaceholder: "vas@email.com",
    password: "Lozinka",
    passwordPlaceholder: "Najmanje 8 znakova",
    confirmPassword: "Potvrdi lozinku",
    confirmPasswordPlaceholder: "Ponovite lozinku",
    registerButton: "Kreiraj račun",
    alreadyHaveAccount: "Već imate račun?",
    loginLink: "Prijavite se ovdje",
    accountCreated: "Račun uspješno kreiran!",
    accountCreatedPendingActivation: "Registracija uspješna! Vaš račun mora biti aktiviran od strane administratora prije nego što se možete prijaviti.",
    registrationFailed: "Registracija nije uspjela",
    passwordsDontMatch: "Lozinke se ne podudaraju",
    passwordTooShort: "Lozinka mora imati najmanje 8 znakova",
  },

  login: {
    title: "Dobrodošli nazad",
    subtitle: "Prijavite se na svoj {appTitle} račun",
    email: "Email",
    emailPlaceholder: "vas@email.com",
    password: "Lozinka",
    passwordPlaceholder: "Vaša lozinka",
    rememberDevice: "Zapamti ovaj uređaj",
    loginButton: "Prijavi se",
    forgotPassword: "Zaboravili ste lozinku?",
    notRegistered: "Još niste registrovani?",
    registerLink: "Kreirajte račun",
    loginSuccess: "Uspješno prijavljivanje!",
    loginFailed: "Prijava nije uspjela",
    invalidCredentials: "Nevažeći email ili lozinka",
  },

  pdf: {
    project: "Projekt",
    scanOrEnter: "Skenirajte QR kod ili unesite kod",
  },

  profile: {
    title: "Profil",
    subtitle: "Upravljajte svojim profilom i sigurnosnim postavkama",
    editProfile: "Uredi profil",
    changePassword: "Promijeni lozinku",
    currentPassword: "Trenutna lozinka",
    newPassword: "Nova lozinka",
    confirmPassword: "Potvrdi lozinku",
    profileUpdated: "Profil uspješno ažuriran!",
    passwordChanged: "Lozinka uspješno promijenjena!",
    profileInfo: "Informacije o profilu",
    profileInfoDesc: "Ažurirajte svoje ime i email adresu",
    name: "Ime",
    email: "Email",
    security: "Sigurnost",
    securityDesc: "Promijenite svoju lozinku",
    oldPassword: "Trenutna lozinka",
    newPasswordLabel: "Nova lozinka",
    confirmPasswordLabel: "Potvrdi novu lozinku",
    updateProfile: "Ažuriraj profil",
    updatePassword: "Promijeni lozinku",
    accountInfo: "Informacije o računu",
    accountDetails: "Detalji o vašem računu",
    role: "Uloga",
    roleAdmin: "Administrator",
    roleUser: "Korisnik",
    createdAt: "Kreiran",
    lastLogin: "Zadnja prijava",
    logoutSection: "Odjava",
    logoutDesc: "Odjavite se sa svog računa",
    logoutButton: "Odjavi se",
    errors: {
      profileUpdateFailed: "Greška pri ažuriranju profila",
      passwordChangeFailed: "Greška pri promjeni lozinke",
      nameEmailRequired: "Ime i email su obavezni",
      allFieldsRequired: "Sva polja su obavezna",
      passwordMismatch: "Nove lozinke se ne poklapaju",
      passwordTooShort: "Nova lozinka mora imati najmanje 8 karaktera",
    },
  },

  images: {
    title: "Slike",
    uploadImages: "Učitaj slike",
    uploadInProgress: "Učitavanje u toku...",
    dragAndDrop: "Prevucite slike ovdje ili kliknite za odabir",
    selectImages: "Odaberi slike",
    imageCount: "Broj slika",
    totalSize: "Ukupna veličina",
    setAsAvatar: "Postavi kao avatar",
    avatarSet: "Avatar postavljen",
    deleteImage: "Obriši sliku",
    confirmDeleteImage: "Da li ste sigurni da želite obrisati ovu sliku?",
    imageDeleted: "Slika je obrisana",
    imagesUploaded: "Slike su učitane",
    uploadFailed: "Učitavanje nije uspjelo",
    noImages: "Nema slika",
    uploadFirstImage: "Učitajte prvu sliku",
    preview: "Pregled",
    original: "Original",
    thumbnail: "Minijatura",
    dimensions: "Dimenzije",
    fileSize: "Veličina datoteke",
    uploadedAt: "Učitano",
      gcsNotConfigured: "GCS nije konfigurisan",
      imageNotAvailable: "Slika nije dostupna",
      noExifData: "Nema dostupnih EXIF metapodataka za ovu sliku.",
    downloadError: "Greška pri preuzimanju slike",
    downloadErrorMultiple: "Greška pri preuzimanju slika",
    downloadSuccess: "Preuzimanje",
    downloadAllSuccess: "Preuzimanje slika...",
  },

  theme: {
    toggleDark: "Prebaci na tamnu temu",
    toggleLight: "Prebaci na svijetlu temu",
  },

  packages: {
    title: "Paketi",
    description: "Upravljajte predefiniranim paketima za vaše klijente",
    createPackage: "Kreiraj paket",
    editPackage: "Uredi paket",
    packageName: "Naziv paketa",
    packageDescription: "Opis",
    packagePrice: "Cijena",
    isActive: "Aktivan",
    items: "Sadržaj",
    addItem: "Dodaj stavku",
    itemType: "Tip",
    itemQuantity: "Količina",
    printFormat: "Format ispisa",
    digital: "Digitalne slike",
    print: "Fizički ispis",
    video: "Video zapisi",
    noPackages: "Nema dostupnih paketa",
    createFirstPackage: "Kreirajte vaš prvi paket",
    packageCreated: "Paket kreiran",
    packageUpdated: "Paket ažuriran",
    packageDeleted: "Paket obrisan",
    deletePackage: "Obriši paket",
    deletePackageConfirm: "Jeste li sigurni da želite obrisati ovaj paket?",
    printFormatRequired: "Odaberite format ispisa za svaku print stavku.",
    packageSelection: "Odabir paketa",
    selectPackage: "Odaberite paket",
    manualSelection: "Ručni odabir",
    manualSelectionDescription: "Odaberite pojedinačne medije bez paketa",
    packageIncludes: "Paket uključuje:",
    digitalImages: "{count} digitalne slike",
    physicalPrints: "{count}x Ispis {format}",
    videos: "{count} video zapisa",
    selectThisPackage: "Odaberi ovaj paket",
    selectedPackage: "Odabrani paket",
    packageLimit: "Limit paketa dostignut",
    packageLimitWarning: "Dostigli ste limit za ovaj tip medija",
    remainingDigital: "Preostalo: {count} slika",
    remainingPrints: "Preostalo: {count} ispisa",
    remainingVideos: "Preostalo: {count} videozapisa",
  },

  accessCodes: {
    title: "Pristupni kodovi",
    generateCodes: "Generiši kodove",
    codesGenerated: "Kodovi su generisani",
    numberOfCodes: "Broj kodova",
    generateCodesDescription: "Unesite broj kodova za generisanje",
    downloadPDF: "Preuzmi PDF",
    pdfGenerated: "PDF je generisan",
    code: "Kod",
    usageCount: "Broj korištenja",
    lastUsed: "Zadnje korištenje",
    invalidated: "Poništen",
    invalidate: "Poništi",
    confirmInvalidate: "Da li ste sigurni da želite poništiti ovaj kod?",
    codeInvalidated: "Kod je poništen",
    noCodes: "Nema pristupnih kodova",
    generateFirstCodes: "Generiši prve kodove",
    printInstructions: "Štampajte ili podijelite pristupne kodove sa vašim klijentima",
    active: "Aktivni",
    used: "Korišteni",
    downloadImage: "Preuzmi kao sliku",
    imageDownloaded: "QR kod je preuzet kao slika",
  },
};

// Removed invalid type reference to 'en' to avoid TS error